module.exports = __webpack_public_path__ + "img/first-second-opened.96e48733.webp";